import React, {useState, useEffect, useContext} from "react";

import { API_URL, POST_TRESHOLD_ORDERS } from "../../../constants";
import { ContextOrders } from "../../../Context/ContextOrders";
import { GET_TOKEN } from "../../../helpers";

import { LoadingSpinner } from "../../dashboard/partials/LoadingSpinner";
import { ReactTable } from "../../Global/ReactTable/ReactTable";
import { Modal } from "../../Global/Modal/Modal";
import { EmptyData } from "../../Global/EmptyData/EmptyData";

import "./Orders.css";

export const Orders = () => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [ordersData, setOrdersData] = useState([]);

  const ordersContext = useContext(ContextOrders);


  // const [modalActive, setModalActive] = useState(false);
  // const [instructionsTextbox, setInstructionsTextbox] = useState('');

  useEffect(() => {
    setDataLoaded(false)

    fetch(API_URL + POST_TRESHOLD_ORDERS, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => setOrdersData([...response]))
      .catch(err => console.error(err))
      .finally(() => setDataLoaded(true))
  }, []);

  // POST /api/orders/{id}/approve (middleware type4)

  const approveOrderSubmit = (id) => {
    fetch(API_URL + POST_TRESHOLD_ORDERS + `/${id}/approve`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
    .then((response) => response.json())
    .then((response) => {
      setOrdersData([...response])
    })
    .catch(error => console.log(error))
    .finally(() => ordersContext.getOrdersForMenuNotif());
  }



  const ReturnsCalendarColumns = [
    {
      Header: "Company",
      accessor: "company_name",
      className: "company_name",
    },
    {
      Header: "Contact email",
      accessor: "contact_email",
      className: "contact_email"
    },
    {
      Header: "Region",
      accessor: "region",
      className: "cell_region",
      // country
      Cell: (cell) => {
        return (
          <div className="countryCell">
            <img src={cell.row.original.country.img} alt="flag" className="flag-icon-img"/>
            {cell.row.original.country.name}
          </div>
        )
      },
    },
    {
      Header: "enquiry date & time",
      accessor: "created_at",
      className: "created_at",
    },
    {
      Header: "Action",
      accessor: "action",
      className: "cell_action",
      Cell: (cell) => {
        return <button 
          className='default_button'
          type="submit"
          onClick={() => {
            approveOrderSubmit(cell.row.original.id)
          }}
        >
            Approve order
          </button>
      },
    }
  ];

  const ReturnsList = () => {
    return <ReactTable className="ordersDataListTable" columns={ReturnsCalendarColumns} data={ordersData} />
  }

  return (
    <div className='OrdersList'>
      <div className="Dashboard__content__top-row">
        <h2> Orders </h2>
      </div>

      {dataLoaded 
        ? ordersData.length > 0 ? ReturnsList() : <EmptyData title='You don’t have any orders'/>
        : <LoadingSpinner/>
      }
    </div>
  );
};
